import {
    clinicSecretaryHasAgendaView,
    clinicSecretaryHasChatSettingsView,
    clinicSecretaryHasChatView,
    clinicSecretaryHasPatientTabView,
    clinicSecretaryHasRequestsView,
    clinicSecretaryHasTeamChatView,
} from "@/domains/multi/clinicSecretaryPermissions";
import { SECRETARY_NAV_TRANSLATIONS } from "@/domains/shared/navigation/constants";
import type { SecretaryNavItem } from "@/domains/shared/navigation/secretaryNav";
import { getTranslation } from "@mivo/i18n";
import { CalendarDays, HelpCircle, LayoutDashboard, MessageCircle, Settings, User, Users } from "lucide-react";

export function buildClinicSecretaryNav(): SecretaryNavItem[] {
    const nav: SecretaryNavItem[] = [
        { to: "/administrativo", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.home), icon: LayoutDashboard, end: true },
    ];

    if (clinicSecretaryHasAgendaView()) {
        nav.push({ to: "/administrativo/agenda", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.agenda), icon: CalendarDays });
    }

    if (clinicSecretaryHasPatientTabView("generalView")) {
        nav.push({ to: "/administrativo/pacientes", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.patients), icon: Users });
    }

    if (clinicSecretaryHasRequestsView()) {
        nav.push({ to: "/administrativo/solicitacoes", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.requests), icon: HelpCircle });
    }

    if (clinicSecretaryHasChatView()) {
        nav.push({ to: "/administrativo/chat", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.patientChat), icon: MessageCircle });
    }

    if (clinicSecretaryHasTeamChatView()) {
        nav.push({ to: "/administrativo/chat-equipe", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.teamChat), icon: MessageCircle });
    }

    if (clinicSecretaryHasChatSettingsView()) {
        nav.push({ to: "/administrativo/configuracoes/chat", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.settings), icon: Settings });
    }

    nav.push({ to: "/administrativo/perfil", label: getTranslation(SECRETARY_NAV_TRANSLATIONS.profile), icon: User });
    return nav;
}
